module.exports = __webpack_public_path__ + "img/2-4.3c6ea0b6.svg";